import { ref } from 'vue';

const socialShareUrls = ref({
  facebook: null,
  instagram: null
});


export function useSocialShare() {
  async function fetchSocialUrls(apiUrl, mediaItemId, distributionId) {
    const url = `${apiUrl}/qr?mediaItemId=${mediaItemId}&distributionId=${distributionId}&get_social_url=true`;

    try {
      const response = await fetch(url, { method: 'GET' });

      if (!response.ok) {
        throw new Error(`Error getting social URLs: ${response.statusText}`);
      }

      const data = await response.json();
      // Process the results and store the full URLs
      const urls = {};
      data.results.forEach((result) => {
        urls[result.platform] = result.url;
      });

      socialShareUrls.value = urls;
    } catch (error) {
      console.error('Error making the request:', error.message);
    }
  }

  function shareOnPlatform(platform) {
    if (!socialShareUrls.value[platform]) {
      console.error(`No URL found for platform: ${platform}`);
      return;
    }

    const redirectorUrl = socialShareUrls.value[platform];
    window.open(redirectorUrl, '_blank');
  }

  return { socialShareUrls, fetchSocialUrls, shareOnPlatform };
}
